const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';

registerBlockType('whatsapp-card/block', {
  title: 'Whatsapp card Sumicity',
  description: 'Insira uma descrição para o componente',
  icon: 'admin-site',
  category: 'design',
  attributes,
  edit: (props) => <Edit {...props} />,
  save: function ({ attributes }) {
    return <div> </div>; //null
  },
});
